import ContentClient from '../common/ContentClient';

export class CLPLContentClient extends ContentClient {
    static BASE_URL = '/clpl-api/v1';

    static FORMS_URL = `${CLPLContentClient.BASE_URL}/forms`;

    static CUTSCORES_URL = `${CLPLContentClient.BASE_URL}/cutscores`;
}

export default CLPLContentClient;
